import { render, staticRenderFns } from "./EditableTable.vue?vue&type=template&id=53f584b4&"
import script from "./EditableTable.vue?vue&type=script&lang=js&"
export * from "./EditableTable.vue?vue&type=script&lang=js&"
import style0 from "./EditableTable.vue?vue&type=style&index=0&id=53f584b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports